import React, {useContext, useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";

import {PAContext} from "../../Services/PAContext";

import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Divider, ListItem,
    TextField, Tooltip
} from "@mui/material";
import PAEvent from "../../MasterEventObjects/PAEvent";
import PAAttendee from "../../MasterEventObjects/Attendee";
import usePA_GlobalStore from "../../Services/ZustandGlobalStore";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import {capitalizeFirstLetter} from "../../components/Helpers/TextStyling";
import SavePlanning from "../../components/Dialogs/SavePlanning";
import CreateNewPlanning from "../../components/Dialogs/CreateNewPlanning";
import UnifiedBudget from "../../components/Dialogs/UnifiedBudget";

import AssignmentIcon from '@mui/icons-material/Assignment';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReceiptScanner from "../../components/Dialogs/ReceiptScanner";


function FeaturesList(props) {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, geminiMessages, setAccount } = useContext(PAContext);
    const { Account } = dataArray;

    const [currentFeature, setCurrentFeature] = useState(props.currentFeature);

    useEffect(() => {
        console.log("setCurrentFeature : "+props.currentFeature);
        setCurrentFeature(props.currentFeature);
    }, [props.currentFeature]);

    const [needToSave, setNeedToSave] = useState(false);
    useEffect(() => {
        console.log("PA_GlobalObject.Planning : "+PA_GlobalObject.Planning.need_to_save);
        setNeedToSave(PA_GlobalObject.Planning.need_to_save);

        /*
            see if anything needs to change at the high level
            this may include activities, lodging, meals, flights, supplies, etc

         */


    }, [PA_GlobalObject.Planning.need_to_save]);

    const handleIconClick = (featureName) => {
        // Handle the click event here
        console.log(`Clicked on ${featureName}`);

        //decide whether to show the console or not
        if (featureName !== "Save" && featureName !== "Clear"){
            if (!props.showEventItemConfig){
                //if it's not showing then show it
                props.setShowEventItemConfig(true);
                setCurrentFeature(featureName);

            } else {
                //if it is showing then decide whether it is just changing features and needs to stay open
                // - or - if they are just meaning to close it
                if (featureName === currentFeature){
                    props.setShowEventItemConfig(false);
                    setCurrentFeature("Map");
                } else {
                    setCurrentFeature(featureName);
                }
            }
        }


        switch (featureName) {
            case "Concierge":
                navigate('/Planner/Concierge')
                break;
            case "Details":
                navigate('/Planner/Details')
                break;
            case "Location":
                navigate('/Planner/Location')
                break;
            case "Dates":
                navigate('/Planner/Dates')
                break;
            case "Map":
                props.setShowEventItemConfig(false);
                navigate('/Planner/Map')
                break;
            case "Notes":
                navigate('/Planner/Notes')
                break;
            case "Itinerary":
                navigate('/Planner/Itinerary')
                break;
            case "Documents":
                navigate('/Planner/Documents')
                break;
            case "Activities":
                navigate('/Planner/Activities')
                break;
            case "Ideas":
                navigate('/Planner/Ideas')
                break;
            case "Attendees":
                navigate('/Planner/Attendees')
                break;
            case "Lodging":
                navigate('/Planner/Lodging')
                break;
            case "Flights":
                navigate('/Planner/Flights')
                break;
            case "carRentals":
                navigate('/Planner/CarRentals')
                break;
            case "Cruises":
                navigate('/Planner/Cruises')
                break;
            case "Messages":
                navigate('/Planner/Messages')
                break;
            case "Meals":
                navigate('/Planner/Meals')
                break;
            case "Photos":
                navigate('/Planner/Photos')
                break;
            case "Supplies":
                navigate('/Planner/Supplies')
                break;
            case "Receipts":
                navigate('/Planner/Receipts')
                break;
            case "To-Do":
                navigate('/Planner/Todo')
                break;
            case "Weather":
                navigate('/Planner/Weather')
                break;
            case "Save":
                setIsSavePlanningDialogOpen(true)
                break;
            case "Clear":
                clearPlanning();
                break;
            default:
        }

        props.setShowEventItemExtendedConfig(false);
    };


    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const handleSnackbarClose = () => setSnackbarOpen(false);
    const saveButtonRef = useRef(null);

    function clearPlanning(){
        //show the prompt
        setOpenDialogDelete(true);

    }

    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    function handleDialogDeleteClose() {
        setOpenDialogDelete(false);
    }
    function handleDialogDeleteOK(){
        setOpenDialogDelete(false);

        const _new_event = new PAEvent();
        _new_event.title = "My New Event";
        _new_event.status = 10;

        //see if they are logged in
        if (Object.keys(Account).length === 0){
            //create the default Planner Attendee
            console.log("Need to create the default Planner Attendee");
            const _planner = new PAAttendee(
                'Sample',
                'Planning',
                'sample.planning@example.com');
            _planner.id = "100000";
            _planner.role = 'admin';
            _planner.planner = false;
            _planner.nickname = 'Planner';
            _planner.isSample = true;
            _new_event.attendees.push(_planner);

            //add them to the host array
            _new_event.host = [_planner.id];

            setAccount(_planner);
        } else {
            //they are logged in so use their account
            console.log("User is logged in");

            const _planner = new PAAttendee(
                Account.fname,
                Account.lname,
                Account.email);
            _planner.id = Account.id;
            _planner.created = Account.created;
            _planner.role = Account.role;
            _planner.nickname = Account.nickname;
            _planner.language = Account.language;
            _planner.avatar = Account.avatar;
            _planner.preferred_airport = Account.preferred_airport;

            _planner.address = Account.address;
            _planner.city = Account.city;
            _planner.state = Account.state;
            _planner.zip = Account.zip;
            _planner.country = Account.country;

            _planner.email = Account.email;
            _planner.dob = Account.dob;

            _planner.phone_prefix = Account.phone_prefix;
            _planner.phone = Account.phone;
            _planner.mask_phone_number = Account.mask_phone_number;

            _planner.events = Account.events;
            _planner.documents = Account.documents;

            _new_event.attendees.push(_planner);

            //add them to the host array
            _new_event.host = [Account.id];

        }

        console.log("_new_event", _new_event);

        set_PA_GlobalObject({ Planning: _new_event });

    }

    const [isUnifiedBudgetDialogOpen, setIsUnifiedBudgetDialogOpen] = useState(false);
    const [isSavePlanningDialogOpen, setIsSavePlanningDialogOpen] = useState(false);
    const [isReceiptScannerDialogOpen, setIsReceiptScannerDialogOpen] = useState(false);

    const [isExpenseReportOpen, setIsExpenseReportOpen] = useState(false);
    const [expenseReport, setExpenseReport] = useState([]);
    const [email, setEmail] = useState("");

    const attendeesWithExpenses = PA_GlobalObject.Planning.attendees.filter((attendee) =>
        [PA_GlobalObject.Planning.lodging, PA_GlobalObject.Planning.meals, PA_GlobalObject.Planning.activities, PA_GlobalObject.Planning.flights].some((category) =>
            category.some((item) =>
                item.attendees?.some((att) => att.id === attendee.id && att.is_business_expense)
            )
        )
    );

    const formatDate = (timestamp) => (timestamp ? dayjs(timestamp).format("MMM D, YYYY") : "N/A");


    useEffect(() => {
        generateExpenseReport();
    }, [
        PA_GlobalObject.Planning.attendees,
        PA_GlobalObject.Planning.lodging,
        PA_GlobalObject.Planning.meals,
        PA_GlobalObject.Planning.activities]);

    // Function to generate the report data
    const generateExpenseReport = () => {
        const report = [];

        PA_GlobalObject.Planning.attendees.forEach(attendee => {
            const attendeeExpenses = {
                name: `${attendee.fname} ${attendee.lname}`,
                lodging: PA_GlobalObject.Planning.lodging
                    .filter(item => item.attendees.some(a => a.id === attendee.id && a.is_business_expense))
                    .reduce((sum, item) => sum + (item.attendees.find(a => a.id === attendee.id)?.business_expense_amount || 0), 0),
                meals: PA_GlobalObject.Planning.meals
                    .filter(item => item.attendees.some(a => a.id === attendee.id && a.is_business_expense))
                    .reduce((sum, item) => sum + (item.attendees.find(a => a.id === attendee.id)?.business_expense_amount || 0), 0),
                activities: PA_GlobalObject.Planning.activities
                    .filter(item => item.attendees.some(a => a.id === attendee.id && a.is_business_expense))
                    .reduce((sum, item) => sum + (item.attendees.find(a => a.id === attendee.id)?.business_expense_amount || 0), 0),
                total: 0
            };
            attendeeExpenses.total = attendeeExpenses.lodging + attendeeExpenses.meals + attendeeExpenses.activities;
            report.push(attendeeExpenses);
        });

        console.log("generateExpenseReport : ", report);

        setExpenseReport(report);
    };

    // Function to handle sending report via email
    const handleSendReport = () => {
        if (!email) {
            alert("Please enter an email address.");
            return;
        }

        const reportData = expenseReport.map(attendee => ({
            Name: attendee.name,
            Lodging: `$${attendee.lodging.toFixed(2)}`,
            Meals: `$${attendee.meals.toFixed(2)}`,
            Activities: `$${attendee.activities.toFixed(2)}`,
            Total: `$${attendee.total.toFixed(2)}`
        }));

        console.log("Sending report to:", email, reportData);

        // TODO: Implement actual email sending logic
        alert(`Report sent to ${email}`);
    };

    // Function to handle exporting report as CSV
    const handleExportCSV = () => {
        let csvContent = "Name,Lodging,Meals,Activities,Total\n";
        expenseReport.forEach(attendee => {
            csvContent += `${attendee.name},${attendee.lodging.toFixed(2)},${attendee.meals.toFixed(2)},${attendee.activities.toFixed(2)},${attendee.total.toFixed(2)}\n`;
        });

        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Business_Expense_Report.csv";
        a.click();
    };

    function onExpenseReportClose() {
        setIsExpenseReportOpen(false);
    }

    const [expandedItems, setExpandedItems] = useState({});

    // Function to toggle expansion
    const toggleExpand = (attendeeId, itemId) => {
        const key = `${attendeeId}-${itemId}`; // Create a unique key
        setExpandedItems((prev) => ({
            ...prev,
            [key]: !prev[key], // Toggle only for this attendee's specific item
        }));
    };

    const getHostTierIcon = (eventCount) => {
        if (eventCount >= 51) {
            return <i className="icon-star" style={{color: 'goldenrod', fontSize: '16px'}}/>;
        } else if (eventCount >= 21) {
            return <i className="icon-crown" style={{color: 'purple', fontSize: '16px'}}/>;
        } else if (eventCount >= 11) {
            return <i className="icon-diamond2" style={{color: 'silver', fontSize: '16px'}}/>;
        } else if (eventCount >= 4) {
            return <i className="icon-fire" style={{color: 'orangered', fontSize: '16px'}}/>;
        } else if (eventCount >= 1) {
            return <i className="icon-happy" style={{color: 'green', fontSize: '16px'}}/>;
        } else {
            return null; // or a default icon
        }
    };

    const [isCreateNewPlanningDialogOpen, setIsCreateNewPlanningDialogOpen] = useState(false);

    const [showAnalyzer, setShowAnalyzer] = useState(false);
    const handleRunAnalyzer = () => {
        setShowAnalyzer(true); // open the dialog
    };


    return (

        <div>

            <Box
                className="feature-dock-container"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    px: 1.5,
                    height: '65px', // STRICT HEIGHT LIMIT
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    bgcolor: '#f8fafc',
                    borderRadius: '20px',
                    border: '1px solid #e2e8f0',
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none'
                }}
            >
                {/* --- 1. THE ADVENTURE BUTTON --- */}
                <Box sx={{ flexShrink: 0, pr: 1, borderRight: '1px solid #e2e8f0', height: '45px', display: 'flex', alignItems: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={() => setIsCreateNewPlanningDialogOpen(!isCreateNewPlanningDialogOpen)}
                        sx={{
                            background: 'linear-gradient(135deg, #fff3e0 0%, #ffebd2 100%)',
                            color: '#f09637',
                            border: '1px solid #fccca5',
                            borderRadius: '12px',
                            minWidth: '80px',
                            height: '40px',
                            px: 1.5,
                            boxShadow: '0 2px 8px rgba(240, 150, 55, 0.1)',
                            textTransform: 'none',
                        }}
                    >
                        <Typography sx={{ fontSize: '10px', fontWeight: 900, lineHeight: 1 }}>PLAN</Typography>
                    </Button>
                </Box>

                {(() => {
                    const planning = usePA_GlobalStore.getState().PA_GlobalObject.Planning || {};

                    // COMPACT ICON RENDERER
                    const renderIcon = (id, iconClass, color, title, badgeCount = 0, hasAlert = false, alertColor = "green", customAction = null) => {
                        const isActive = currentFeature === id;
                        const handleClick = customAction ? customAction : () => handleIconClick(id);

                        const glowColor = color || '#0ea5e9';

                        return (

                            <Tooltip
                                key={id}
                                title={title}
                                arrow
                                placement="top"
                                enterDelay={200}
                                slotProps={{
                                    popper: {
                                        sx: {
                                            // Matching colorful glass indicator arrow
                                            '& .MuiTooltip-arrow': {
                                                color: 'rgba(255, 255, 255, 0.5)',
                                                '&::before': {
                                                    border: `1px solid ${glowColor}60`, // Tinted soft border
                                                    backgroundColor: `${glowColor}15`, // Translucent color tint
                                                    backdropFilter: 'blur(10px) saturate(140%)',
                                                }
                                            }
                                        }
                                    },
                                    tooltip: {
                                        sx: {
                                            // Vivid Colorful Glassmorphism
                                            background: `linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, ${glowColor}18 100%)`,
                                            backdropFilter: 'blur(16px) saturate(160%)',

                                            // Drop shadow matching the icon's color palette
                                            boxShadow: `0 8px 24px -4px ${glowColor}25, 0 2px 6px -1px ${glowColor}15`,

                                            // Crisp, tinted glowing border perimeter
                                            border: `1px solid ${glowColor}50`,

                                            // Pull the exact vibrant color for the text label
                                            color: glowColor === '#fff' ? '#1e293b' : glowColor,

                                            borderRadius: '10px',
                                            padding: '7px 12px',
                                            fontSize: '11px',
                                            fontWeight: 800, // Punchy font weight to pop out on blur
                                            letterSpacing: '0.03em',
                                            textTransform: 'uppercase', // Matches your under-label aesthetics
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            '&::before': {
                                                content: '""',
                                                width: '5px',
                                                height: '5px',
                                                borderRadius: '50%',
                                                backgroundColor: glowColor, // Tiny matching micro-bullet point indicator
                                            }
                                        }
                                    }
                                }}
                            >
                                <Badge
                                    key={id}
                                    badgeContent={badgeCount}
                                    sx={{ '& .MuiBadge-badge': { bgcolor: '#ffedd5', color: '#9a3412', fontWeight: 800, fontSize: '9px', height: '14px', minWidth: '14px' } }}
                                >
                                    <IconButton
                                        onClick={handleClick}
                                        sx={{
                                            width: 38, // Slightly smaller to fit 65px
                                            height: 38,
                                            borderRadius: '10px',
                                            color: isActive ? color : '#94a3b8',
                                            bgcolor: isActive ? '#fff' : 'transparent',
                                            border: isActive ? '1px solid #fde68a' : '1px solid transparent',
                                            '&:hover': { bgcolor: 'rgba(255,255,255,0.8)' }
                                        }}
                                    >
                                        <i className={iconClass} style={{ fontSize: '16px' }} />
                                    </IconButton>
                                </Badge>
                            </Tooltip>

                        );
                    };

                    // GROUP WRAPPER WITH SUBTLE UNDER-LABEL
                    const renderGroup = (label, icons) => (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center' }}>
                            <Box sx={{ display: 'flex', gap: 0.5, p: 0.5, bgcolor: 'rgba(255,255,255,0.5)', borderRadius: '12px' }}>
                                {icons}
                            </Box>
                            <Typography sx={{ fontSize: '8px', fontWeight: 900, color: '#94a3b8', mt: -0.2, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                {label}
                            </Typography>
                        </Box>
                    );

                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {/* --- ESSENTIALS --- */}
                            {renderGroup("Essentials", [
                                renderIcon("Concierge", "icon-magic-wand", "#0ea5e9", "Gemini", geminiMessages.length),
                                renderIcon("Details", "icon-settings-icons", "#0ea5e9", "Details", 0, true, planning.title?.length > 3 ? 'green' : 'red'),
                                renderIcon("Dates", "icon-calendar3", "#0ea5e9", "Dates", 0, planning.time_table?.dates?.length > 0),
                                renderIcon("Attendees", "icon-group", "#f59e0b", "Attendees", planning.attendees?.length || 0)
                            ])}

                            {/* --- LOGISTICS --- */}
                            {renderGroup("Logistics", [
                                renderIcon("Flights", "icon-airplane", "#0ea5e9", "Flights", planning.flights?.length || 0),
                                renderIcon("Lodging", "icon-bed", "#0ea5e9", "Lodging", planning.lodging?.length || 0),
                                renderIcon("Itinerary", "icon-calendar", "#0ea5e9", "Itinerary"),
                                renderIcon("Weather", "icon-sun-wind", "#0ea5e9", "Weather")
                            ])}

                            {/* --- TOOLS --- */}
                            {renderGroup("Tools", [
                                renderIcon("Budget", "icon-wallet", "#0ea5e9", "Budget", 0, true, 'green', () => setIsUnifiedBudgetDialogOpen(true)),
                                renderIcon("To-Do", "icon-checklist-time", "#0ea5e9", "To-Do", planning.to_do?.length || 0),
                                renderIcon("Supplies", "icon-checklist2", "#0ea5e9", "Supplies", planning.supplies?.length || 0),
                                renderIcon("Documents", "icon-file-lock", "#0ea5e9", "Documents", planning.documents?.length || 0),
                                renderIcon("Scanner", "icon-shutter", "#910ee9", "Scanner", 0, true, 'green', () => setIsReceiptScannerDialogOpen(true)),
                            ])}

                            {/* --- ASSETS --- */}
                            {renderGroup("Assets", [
                                renderIcon("Ideas", "icon-lamp-bright", "#0ea5e9", "Ideas", planning.ideas?.length || 0),
                                renderIcon("Activities", "icon-list-heart", "#0ea5e9", "Activities", planning.activities?.length || 0),
                                renderIcon("Meals", "icon-fork-knife2", "#0ea5e9", "Meals", planning.meals?.length || 0),
                                renderIcon("Photos", "icon-picture2", "#0ea5e9", "Photos", planning.photos?.length || 0),
                                renderIcon("Receipts", "icon-receipt", "#0ea5e9", "Receipts", planning.receipts?.length || 0)
                            ])}

                            {/* --- SOCIAL --- */}
                            {renderGroup("Social", [
                                renderIcon("Messages", "icon-smartphone-text", "#0ea5e9", "Messaging", planning.messages?.length || 0),
                                renderIcon("Notes", "icon-notebook", "#0ea5e9", "Notes", planning.notes?.length || 0),

                                PA_GlobalObject.Planning.status === 10 ? renderIcon("Save", "icon-floppy-disk", "#0ea5e9", "Save") : null,

                                renderIcon("Clear", "icon-trash", "#0ea5e9", "Clear")
                            ].filter(Boolean))}
                        </Box>
                    );
                })()}
            </Box>

            <Dialog
                open={openDialogDelete}
                onClose={handleDialogDeleteClose}
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        padding: '8px',
                        maxWidth: '400px',
                        boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'
                    }
                }}
            >
                {/* Header / Close Button */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={handleDialogDeleteClose} size="small" sx={{ color: 'text.secondary' }}>
                        <i className="icon-cross" />
                    </IconButton>
                </Box>

                <DialogContent sx={{ textAlign: 'center', pt: 0 }}>
                    {/* Illustrated Icon Area */}
                    <Box
                        sx={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            bgcolor: '#fff7ed', // orange.50
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px',
                            color: '#f09637',
                            position: 'relative'
                        }}
                    >
                        <AssignmentIcon sx={{ fontSize: 40 }} />
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                bgcolor: 'white',
                                borderRadius: '50%',
                                p: 0.5,
                                boxShadow: 2,
                                color: '#d32f2f',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <AutorenewIcon sx={{ fontSize: 18, fontWeight: 'bold' }} />
                        </Box>
                    </Box>

                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: '#1a1a1a' }}>
                        Ready for a Fresh Start?
                    </Typography>

                    <Typography sx={{ color: 'text.secondary', fontSize: '14px', lineHeight: 1.6 }}>
                        You are about to close the session for <br />
                        <strong style={{ color: '#f09637' }}>{PA_GlobalObject.Planning.title}</strong>.
                    </Typography>

                    <Box
                        sx={{
                            mt: 3,
                            p: 1.5,
                            bgcolor: '#fffef0',
                            border: '1px solid #ffeeba',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            textAlign: 'left'
                        }}
                    >
                        <Box sx={{ color: '#856404', display: 'flex' }}>
                            <ErrorOutlineIcon />
                        </Box>
                        <Typography sx={{ color: '#856404', fontSize: '12px', fontWeight: 500 }}>
                            Any unsaved progress will be cleared. This action cannot be undone.
                        </Typography>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3, flexDirection: 'column', gap: 1 }}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDialogDeleteOK}
                        sx={{
                            bgcolor: '#f09637',
                            color: 'white',
                            fontWeight: 700,
                            textTransform: 'none',
                            py: 1.2,
                            borderRadius: '10px',
                            fontSize: '15px',
                            '&:hover': {
                                bgcolor: '#d9822b',
                                boxShadow: '0 4px 12px rgba(240, 150, 55, 0.3)'
                            }
                        }}
                    >
                        Yes, Clear Workspace
                    </Button>

                    <Button
                        fullWidth
                        onClick={handleDialogDeleteClose}
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: '14px',
                            '&:hover': { bgcolor: 'transparent', color: 'text.primary' }
                        }}
                    >
                        Keep Working
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Unified Budget Dialog */}
            <UnifiedBudget
                isOpen={isUnifiedBudgetDialogOpen}
                onClose={() => setIsUnifiedBudgetDialogOpen(false)}
            />

            <Dialog open={isExpenseReportOpen} onClose={onExpenseReportClose} fullWidth maxWidth="md">
                <DialogTitle>Business Expense Report</DialogTitle>
                <DialogContent>
                    {attendeesWithExpenses.length === 0 ? (
                        <Typography>No business expenses found.</Typography>
                    ) : (
                        attendeesWithExpenses.map((attendee) => {
                            const attendeeExpenses = {
                                lodging: PA_GlobalObject.Planning.lodging.filter((lodgingItem) =>
                                    lodgingItem.attendees?.some(
                                        (att) => att.id === attendee.id && att.is_business_expense
                                    )
                                ),
                                meals: PA_GlobalObject.Planning.meals.filter((mealItem) =>
                                    mealItem.attendees?.some(
                                        (att) => att.id === attendee.id && att.is_business_expense
                                    )
                                ),
                                activities: PA_GlobalObject.Planning.activities.filter((activityItem) =>
                                    activityItem.attendees?.some(
                                        (att) => att.id === attendee.id && att.is_business_expense
                                    )
                                ),
                                flights: PA_GlobalObject.Planning.flights.filter((flightItem) =>
                                    flightItem.attendees?.some(
                                        (att) => att.id === attendee.id && att.is_business_expense
                                    )
                                ),
                            };

                            // Calculate the total for the attendee grouped by currency
                            const totalExpensesByCurrency = {};
                            Object.values(attendeeExpenses).forEach((category) => {
                                category.forEach((item) => {
                                    const expense = item.attendees.find((att) => att.id === attendee.id);
                                    const currency = item.currency || "USD"; // Default to USD if no currency
                                    const expenseAmount = parseFloat(expense.business_expense_amount) || 0; // Ensure numeric conversion

                                    if (!totalExpensesByCurrency[currency]) {
                                        totalExpensesByCurrency[currency] = 0;
                                    }

                                    totalExpensesByCurrency[currency] += expenseAmount; // Correct numeric summation
                                });
                            });

                            return (
                                <div key={attendee.id} style={{marginBottom: "20px"}}>
                                    {/* Attendee Name & Total grouped by currency */}
                                    <Box display="flex" justifyContent="space-between">
                                        <Typography variant="h6">
                                            {capitalizeFirstLetter(attendee.fname)} {capitalizeFirstLetter(attendee.lname)}
                                        </Typography>
                                        <Box textAlign="right">
                                            {Object.entries(totalExpensesByCurrency).map(([currency, total]) => (
                                                <Typography key={currency} variant="h6" color="primary">
                                                    {total.toFixed(2)} {currency}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </Box>
                                    <Divider style={{marginBottom: "10px"}}/>

                                    {Object.entries(attendeeExpenses).map(([category, items]) => {
                                        if (items.length === 0) return null;

                                        // Calculate totals per currency for this category
                                        const categoryTotalsByCurrency = {};
                                        items.forEach((item) => {
                                            const expense = item.attendees.find((att) => att.id === attendee.id);
                                            const currency = item.currency || "USD";
                                            const expenseAmount = parseFloat(expense.business_expense_amount) || 0; // Ensure numeric conversion

                                            if (!categoryTotalsByCurrency[currency]) {
                                                categoryTotalsByCurrency[currency] = 0;
                                            }
                                            categoryTotalsByCurrency[currency] += expenseAmount;
                                        });

                                        return (
                                            <div key={category} style={{marginBottom: "15px"}}>
                                                {/* Category Name & Total grouped by currency */}
                                                {Object.entries(categoryTotalsByCurrency).map(([currency, total]) => (
                                                    <Box key={currency} display="flex" justifyContent="space-between"
                                                         fontWeight="bold">
                                                        <Typography variant="subtitle1" color="primary">
                                                            {category.charAt(0).toUpperCase() + category.slice(1)}
                                                        </Typography>
                                                        <Typography variant="subtitle1" color="primary">
                                                            {Number(total || 0).toFixed(2)} {currency}
                                                        </Typography>
                                                    </Box>
                                                ))}

                                                {/* List of Expenses (Light Gray) */}
                                                <List dense style={{
                                                    backgroundColor: "#f8f8f8",
                                                    padding: "5px 10px",
                                                    borderRadius: "5px"
                                                }}>
                                                    {items.map((item) => {
                                                        const expense = item.attendees.find((att) => att.id === attendee.id);
                                                        if (!expense || !expense.is_business_expense) return null; // Skip items without business expenses

                                                        const uniqueKey = `${attendee.id}-${item.id}`; // Unique key per attendee-item pair
                                                        const isExpanded = expandedItems[uniqueKey] || false;

                                                        return (
                                                            <ListItem key={uniqueKey} alignItems="flex-start">
                                                                {/* Primary Section with Toggle Button */}
                                                                <ListItemText
                                                                    primary={
                                                                        <Box display="flex"
                                                                             justifyContent="space-between"
                                                                             alignItems="center" width="100%">
                                                                            <Typography
                                                                                variant="body2">{item.name || item.title}</Typography>
                                                                            <Box display="flex" alignItems="center">
                                                                                <Typography variant="body2">
                                                                                    <strong>{Number(expense?.business_expense_amount || 0).toFixed(2)} {item.currency || "USD"}</strong>
                                                                                </Typography>
                                                                                <IconButton size="small"
                                                                                            onClick={() => toggleExpand(attendee.id, item.id)}
                                                                                            sx={{marginLeft: "8px"}}>
                                                                                    {isExpanded ?
                                                                                        <i className="icon-chevron-up"/> :
                                                                                        <i className="icon-chevron-down"/>}
                                                                                </IconButton>
                                                                            </Box>
                                                                        </Box>
                                                                    }
                                                                    secondary={isExpanded && (
                                                                        <Box textAlign="right"
                                                                             sx={{marginTop: "8px", width: "100%"}}>
                                                                            <Typography variant="body2"
                                                                                        color="textPrimary"
                                                                                        fontWeight="bold">
                                                                                Auth & Payment
                                                                            </Typography>
                                                                            <Box display="flex" flexDirection="column"
                                                                                 alignItems="flex-end" gap={0.5}>
                                                                                <Typography variant="body2"
                                                                                            color="textSecondary">
                                                                                    Authorized: {Number(expense.business_expense_amount_authorized || 0).toFixed(2)} {item.currency || "USD"}
                                                                                </Typography>
                                                                                <Typography variant="body2"
                                                                                            color="textSecondary">
                                                                                    Reimbursed: {Number(expense.paid || 0).toFixed(2)} {item.currency || "USD"}
                                                                                </Typography>
                                                                                <Typography variant="body2"
                                                                                            color="textSecondary">
                                                                                    Authorized
                                                                                    By: {expense.business_expense_amount_authorized_by || "N/A"}
                                                                                </Typography>
                                                                                <Typography variant="body2"
                                                                                            color="textSecondary">
                                                                                    Reference
                                                                                    ID: {expense.business_expense_reference_id || "N/A"}
                                                                                </Typography>
                                                                                <Typography variant="body2"
                                                                                            color="textSecondary">
                                                                                    Authorization
                                                                                    Date: {formatDate(expense.business_expense_amount_authorized_timestamp)}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    )}
                                                                />
                                                            </ListItem>
                                                        );
                                                    })}
                                                </List>
                                            </div>
                                        );
                                    })}

                                    {/* Email & Submit Section */}
                                    <Box display="flex" justifyContent="flex-end" alignItems="center" mt={2} gap={1}>
                                        <TextField
                                            label="Recipient Email"
                                            variant="outlined"
                                            type="email"
                                            size="small"
                                            sx={{minWidth: "250px"}}
                                        />
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => alert(`Expense report sent for ${attendee.fname} ${attendee.lname}`)}
                                        >
                                            Submit
                                        </Button>
                                    </Box>

                                    <Divider/>
                                </div>
                            );
                        })
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onExpenseReportClose} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Receipt Scanner Dialog */}
            <ReceiptScanner
                open={isReceiptScannerDialogOpen}
                onClose={() => setIsReceiptScannerDialogOpen(false)}
            />

            <CreateNewPlanning
                isOpen={isCreateNewPlanningDialogOpen}
                onClose={() => setIsCreateNewPlanningDialogOpen(false)}
            />

            <SavePlanning
                isOpen={isSavePlanningDialogOpen}
                onClose={() => setIsSavePlanningDialogOpen(false)}
            />

        </div>

    )
}

export default FeaturesList;
